<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-4 col-md-12 col-sm-12" v-for="(item) in $v.examen_mental.$each.$iter" :key="item.id">
                <div class="list-group-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="item.$model" 
                            :label="item.$model.descripcion" 
                            :type="item.$model.tipo_campo.codigo"
                            :validator="item"
                            v-model="item.$model.examen.valor">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import buttonsCheck from '../baseButtonsCkeck/indexButtonsNoOptions';
import examenMentalService from '../../../../services/examenMentalService';
import examenMentalUsuarioService from '../../../../services/examenMentalUsuarioService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from '../../../../components/common/utilities/toast';
export default {
    props: ['embarazo_actual', 'usuario', 'idHistoria', 'finalizada', 'modo'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            examen_mental: []
        }
    },
    validations(){
        return {
            examen_mental:{
                $each:{
                    examen:{
                        valor:{required}
                    },
                }
            }
        }
    },
    methods:{
        async save() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }

                let examen_mental_usuario = [];

                this.examen_mental.forEach((x) => {
                    if (x.examen.valor !== "") {
                        examen_mental_usuario.push({ ...x.examen });
                    }
                });

                this.LoaderSpinnerShow();
                await examenMentalUsuarioService.store({
                    examen_mental_usuario: examen_mental_usuario,
                });
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito'
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                console.log(error);
                Toast.fire({
                    icon: 'error',
                    title: 'Ha ocurrido un error al procesar la solicitud'
                });
            }
        },
    },
    async created() {
        const filter = {
            sexo: this.usuario.sexo,
            fecha_nacimiento: this.usuario.fecha_nacimiento,
            ...(!isEmpty(this.embarazo_actual) && this.embarazo_actual.activo === 'S' ? { gestante: 'S' } : {})
        };

        const response = await examenMentalService.index({
            params: filter
        });

        const examen_mental_usuario = await examenMentalUsuarioService.index(
            this.idHistoria
        ); 

        this.examen_mental = response.data.map((y) => {
            const indice = examen_mental_usuario.data.findIndex(
                (a) => a.id_examen_mental === y.id
            );
            y.examen = {
                id: indice !== -1 ? examen_mental_usuario.data[indice].id : 0,
                id_usuario: this.usuario.id,
                id_examen_mental: y.id,
                id_historia: this.idHistoria,
                valor: indice !== -1 ? examen_mental_usuario.data[indice].valor : "",
            };
            return y;
        }); 
    }

}
</script>